export var DateFormat;
(function (DateFormat) {
    DateFormat["DashedDateShortTime"] = "YYYY-MM-DD HH:mm A";
    DateFormat["DashedDateTimeFull"] = "MMM-DD-YYYY HH:mm:ss";
    DateFormat["DashedDate"] = "MMM-DD-YYYY";
    DateFormat["DateTime"] = "MMM DD, YYYY, h:mm A";
    DateFormat["Date"] = "MMM DD, YYYY";
    DateFormat["MonthDay"] = "MMM DD";
    DateFormat["MonthSingleDigitDay"] = "MMM D";
    DateFormat["MonthYear"] = "MMMM YYYY";
    DateFormat["LocalizedShortFull"] = "llll";
})(DateFormat || (DateFormat = {}));
//# sourceMappingURL=date-format.js.map